//@flow
import * as React from 'react'
import { useState } from 'react'
import classnames from 'classnames'

import { Flex } from 'components/common'

import { useToggleableSectionStyles } from './styles'

type ToggleableSectionProps = {
  title: string,
  children: React.Node,
  isToggled?: boolean,
  defaultToggled?: boolean,
  onChange?: (isToggled: boolean) => void
}

const ToggleableSection = ({
  title,
  isToggled,
  defaultToggled,
  onChange = () => {},
  children,
  ...props
}: ToggleableSectionProps) => {
  const [isActive, setActive] = useState(defaultToggled !== undefined ? defaultToggled : false)
  const classes = useToggleableSectionStyles()

  const isControlled = isToggled !== undefined
  const isSectionToggled = isControlled ? isToggled : isActive

  const handleToggle = () => (isControlled ? onChange(!isToggled) : setActive(state => !state))

  return (
    <Flex as="section" className={classes.toggleableWrapper} column {...props}>
      <Flex alignCenter className={classes.toggleableHeader} onClick={handleToggle}>
        <i className="icon icon-m">{isSectionToggled ? 'chevrondown' : 'chevronright'}</i>
        <h2>{title}</h2>
      </Flex>
      <div
        className={classnames(classes.toggleableContent, {
          active: isSectionToggled
        })}
      >
        {children}
      </div>
    </Flex>
  )
}

export default ToggleableSection
